export { ErrorType } from '../auth/consts';
export var Syntax;
(function (Syntax) {
    Syntax["CLIENT_ID"] = "client_id";
    Syntax["CLIENT_SECRET"] = "client_secret";
    Syntax["RESPONSE_TYPE"] = "response_type";
    Syntax["SCOPE"] = "scope";
    Syntax["STATE"] = "state";
    Syntax["REDIRECT_URI"] = "redirect_uri";
    Syntax["ERROR"] = "error";
    Syntax["ERROR_DESCRIPTION"] = "error_description";
    Syntax["ERROR_URI"] = "error_uri";
    Syntax["GRANT_TYPE"] = "grant_type";
    Syntax["CODE"] = "code";
    Syntax["ACCESS_TOKEN"] = "access_token";
    Syntax["TOKEN_TYPE"] = "token_type";
    Syntax["EXPIRES_IN"] = "expires_in";
    Syntax["USERNAME"] = "username";
    Syntax["PASSWORD"] = "password";
    Syntax["REFRESH_TOKEN"] = "refresh_token";
})(Syntax || (Syntax = {}));
